import { render } from "./accountList.vue?vue&type=template&id=760c25aa&scoped=true"
import script from "./accountList.vue?vue&type=script&lang=js"
export * from "./accountList.vue?vue&type=script&lang=js"

import "./accountList.vue?vue&type=style&index=0&id=760c25aa&scoped=true&lang=css"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760c25aa"]])

export default __exports__